/**
 * Lista de códigos de país para seletor de telefone
 * 
 * Centraliza a lista de códigos para uso em formulários de contato
 * Inclui os principais países da América, Europa e Ásia
 */

export interface CountryCode {
  code: string;      // DDI E.164 com prefixo '+'
  country: string;   // Nome do país em pt-BR
  flag: string;      // Emoji da bandeira
  iso2?: string;     // Código ISO 3166-1 alpha-2 (ex.: 'BR')
}

/**
 * Lista completa de países (ISO 3166-1) com DDI E.164 e bandeira.
 * Brasil fixado no topo por ser o mercado principal; demais itens
 * ordenados alfabeticamente pelo nome em pt-BR.
 */
export const countryCodes: CountryCode[] = [
  { code: '+55', country: 'Brasil', flag: '🇧🇷', iso2: 'BR' },
  { code: '+93', country: 'Afeganistão', flag: '🇦🇫', iso2: 'AF' },
  { code: '+27', country: 'África do Sul', flag: '🇿🇦', iso2: 'ZA' },
  { code: '+355', country: 'Albânia', flag: '🇦🇱', iso2: 'AL' },
  { code: '+49', country: 'Alemanha', flag: '🇩🇪', iso2: 'DE' },
  { code: '+376', country: 'Andorra', flag: '🇦🇩', iso2: 'AD' },
  { code: '+244', country: 'Angola', flag: '🇦🇴', iso2: 'AO' },
  { code: '+1264', country: 'Anguilla', flag: '🇦🇮', iso2: 'AI' },
  { code: '+1268', country: 'Antígua e Barbuda', flag: '🇦🇬', iso2: 'AG' },
  { code: '+966', country: 'Arábia Saudita', flag: '🇸🇦', iso2: 'SA' },
  { code: '+213', country: 'Argélia', flag: '🇩🇿', iso2: 'DZ' },
  { code: '+54', country: 'Argentina', flag: '🇦🇷', iso2: 'AR' },
  { code: '+374', country: 'Armênia', flag: '🇦🇲', iso2: 'AM' },
  { code: '+297', country: 'Aruba', flag: '🇦🇼', iso2: 'AW' },
  { code: '+61', country: 'Austrália', flag: '🇦🇺', iso2: 'AU' },
  { code: '+43', country: 'Áustria', flag: '🇦🇹', iso2: 'AT' },
  { code: '+994', country: 'Azerbaijão', flag: '🇦🇿', iso2: 'AZ' },
  { code: '+1242', country: 'Bahamas', flag: '🇧🇸', iso2: 'BS' },
  { code: '+973', country: 'Bahrein', flag: '🇧🇭', iso2: 'BH' },
  { code: '+880', country: 'Bangladesh', flag: '🇧🇩', iso2: 'BD' },
  { code: '+1246', country: 'Barbados', flag: '🇧🇧', iso2: 'BB' },
  { code: '+32', country: 'Bélgica', flag: '🇧🇪', iso2: 'BE' },
  { code: '+501', country: 'Belize', flag: '🇧🇿', iso2: 'BZ' },
  { code: '+229', country: 'Benin', flag: '🇧🇯', iso2: 'BJ' },
  { code: '+1441', country: 'Bermudas', flag: '🇧🇲', iso2: 'BM' },
  { code: '+375', country: 'Bielorrússia', flag: '🇧🇾', iso2: 'BY' },
  { code: '+591', country: 'Bolívia', flag: '🇧🇴', iso2: 'BO' },
  { code: '+387', country: 'Bósnia e Herzegovina', flag: '🇧🇦', iso2: 'BA' },
  { code: '+267', country: 'Botsuana', flag: '🇧🇼', iso2: 'BW' },
  { code: '+673', country: 'Brunei', flag: '🇧🇳', iso2: 'BN' },
  { code: '+359', country: 'Bulgária', flag: '🇧🇬', iso2: 'BG' },
  { code: '+226', country: 'Burkina Faso', flag: '🇧🇫', iso2: 'BF' },
  { code: '+257', country: 'Burundi', flag: '🇧🇮', iso2: 'BI' },
  { code: '+975', country: 'Butão', flag: '🇧🇹', iso2: 'BT' },
  { code: '+238', country: 'Cabo Verde', flag: '🇨🇻', iso2: 'CV' },
  { code: '+237', country: 'Camarões', flag: '🇨🇲', iso2: 'CM' },
  { code: '+855', country: 'Camboja', flag: '🇰🇭', iso2: 'KH' },
  { code: '+1', country: 'Canadá', flag: '🇨🇦', iso2: 'CA' },
  { code: '+974', country: 'Catar', flag: '🇶🇦', iso2: 'QA' },
  { code: '+7', country: 'Cazaquistão', flag: '🇰🇿', iso2: 'KZ' },
  { code: '+235', country: 'Chade', flag: '🇹🇩', iso2: 'TD' },
  { code: '+56', country: 'Chile', flag: '🇨🇱', iso2: 'CL' },
  { code: '+86', country: 'China', flag: '🇨🇳', iso2: 'CN' },
  { code: '+357', country: 'Chipre', flag: '🇨🇾', iso2: 'CY' },
  { code: '+57', country: 'Colômbia', flag: '🇨🇴', iso2: 'CO' },
  { code: '+269', country: 'Comores', flag: '🇰🇲', iso2: 'KM' },
  { code: '+242', country: 'Congo', flag: '🇨🇬', iso2: 'CG' },
  { code: '+243', country: 'Congo (RDC)', flag: '🇨🇩', iso2: 'CD' },
  { code: '+850', country: 'Coreia do Norte', flag: '🇰🇵', iso2: 'KP' },
  { code: '+82', country: 'Coreia do Sul', flag: '🇰🇷', iso2: 'KR' },
  { code: '+225', country: 'Costa do Marfim', flag: '🇨🇮', iso2: 'CI' },
  { code: '+506', country: 'Costa Rica', flag: '🇨🇷', iso2: 'CR' },
  { code: '+385', country: 'Croácia', flag: '🇭🇷', iso2: 'HR' },
  { code: '+53', country: 'Cuba', flag: '🇨🇺', iso2: 'CU' },
  { code: '+45', country: 'Dinamarca', flag: '🇩🇰', iso2: 'DK' },
  { code: '+253', country: 'Djibuti', flag: '🇩🇯', iso2: 'DJ' },
  { code: '+1767', country: 'Dominica', flag: '🇩🇲', iso2: 'DM' },
  { code: '+20', country: 'Egito', flag: '🇪🇬', iso2: 'EG' },
  { code: '+503', country: 'El Salvador', flag: '🇸🇻', iso2: 'SV' },
  { code: '+971', country: 'Emirados Árabes Unidos', flag: '🇦🇪', iso2: 'AE' },
  { code: '+593', country: 'Equador', flag: '🇪🇨', iso2: 'EC' },
  { code: '+291', country: 'Eritreia', flag: '🇪🇷', iso2: 'ER' },
  { code: '+421', country: 'Eslováquia', flag: '🇸🇰', iso2: 'SK' },
  { code: '+386', country: 'Eslovênia', flag: '🇸🇮', iso2: 'SI' },
  { code: '+34', country: 'Espanha', flag: '🇪🇸', iso2: 'ES' },
  { code: '+1', country: 'Estados Unidos', flag: '🇺🇸', iso2: 'US' },
  { code: '+372', country: 'Estônia', flag: '🇪🇪', iso2: 'EE' },
  { code: '+251', country: 'Etiópia', flag: '🇪🇹', iso2: 'ET' },
  { code: '+679', country: 'Fiji', flag: '🇫🇯', iso2: 'FJ' },
  { code: '+63', country: 'Filipinas', flag: '🇵🇭', iso2: 'PH' },
  { code: '+358', country: 'Finlândia', flag: '🇫🇮', iso2: 'FI' },
  { code: '+33', country: 'França', flag: '🇫🇷', iso2: 'FR' },
  { code: '+241', country: 'Gabão', flag: '🇬🇦', iso2: 'GA' },
  { code: '+220', country: 'Gâmbia', flag: '🇬🇲', iso2: 'GM' },
  { code: '+233', country: 'Gana', flag: '🇬🇭', iso2: 'GH' },
  { code: '+995', country: 'Geórgia', flag: '🇬🇪', iso2: 'GE' },
  { code: '+350', country: 'Gibraltar', flag: '🇬🇮', iso2: 'GI' },
  { code: '+1473', country: 'Granada', flag: '🇬🇩', iso2: 'GD' },
  { code: '+30', country: 'Grécia', flag: '🇬🇷', iso2: 'GR' },
  { code: '+299', country: 'Groenlândia', flag: '🇬🇱', iso2: 'GL' },
  { code: '+590', country: 'Guadalupe', flag: '🇬🇵', iso2: 'GP' },
  { code: '+1671', country: 'Guam', flag: '🇬🇺', iso2: 'GU' },
  { code: '+502', country: 'Guatemala', flag: '🇬🇹', iso2: 'GT' },
  { code: '+592', country: 'Guiana', flag: '🇬🇾', iso2: 'GY' },
  { code: '+594', country: 'Guiana Francesa', flag: '🇬🇫', iso2: 'GF' },
  { code: '+224', country: 'Guiné', flag: '🇬🇳', iso2: 'GN' },
  { code: '+245', country: 'Guiné-Bissau', flag: '🇬🇼', iso2: 'GW' },
  { code: '+240', country: 'Guiné Equatorial', flag: '🇬🇶', iso2: 'GQ' },
  { code: '+509', country: 'Haiti', flag: '🇭🇹', iso2: 'HT' },
  { code: '+504', country: 'Honduras', flag: '🇭🇳', iso2: 'HN' },
  { code: '+852', country: 'Hong Kong', flag: '🇭🇰', iso2: 'HK' },
  { code: '+36', country: 'Hungria', flag: '🇭🇺', iso2: 'HU' },
  { code: '+967', country: 'Iêmen', flag: '🇾🇪', iso2: 'YE' },
  { code: '+1345', country: 'Ilhas Cayman', flag: '🇰🇾', iso2: 'KY' },
  { code: '+298', country: 'Ilhas Faroé', flag: '🇫🇴', iso2: 'FO' },
  { code: '+500', country: 'Ilhas Malvinas', flag: '🇫🇰', iso2: 'FK' },
  { code: '+91', country: 'Índia', flag: '🇮🇳', iso2: 'IN' },
  { code: '+62', country: 'Indonésia', flag: '🇮🇩', iso2: 'ID' },
  { code: '+98', country: 'Irã', flag: '🇮🇷', iso2: 'IR' },
  { code: '+964', country: 'Iraque', flag: '🇮🇶', iso2: 'IQ' },
  { code: '+353', country: 'Irlanda', flag: '🇮🇪', iso2: 'IE' },
  { code: '+354', country: 'Islândia', flag: '🇮🇸', iso2: 'IS' },
  { code: '+972', country: 'Israel', flag: '🇮🇱', iso2: 'IL' },
  { code: '+39', country: 'Itália', flag: '🇮🇹', iso2: 'IT' },
  { code: '+1876', country: 'Jamaica', flag: '🇯🇲', iso2: 'JM' },
  { code: '+81', country: 'Japão', flag: '🇯🇵', iso2: 'JP' },
  { code: '+962', country: 'Jordânia', flag: '🇯🇴', iso2: 'JO' },
  { code: '+686', country: 'Kiribati', flag: '🇰🇮', iso2: 'KI' },
  { code: '+383', country: 'Kosovo', flag: '🇽🇰', iso2: 'XK' },
  { code: '+856', country: 'Laos', flag: '🇱🇦', iso2: 'LA' },
  { code: '+266', country: 'Lesoto', flag: '🇱🇸', iso2: 'LS' },
  { code: '+371', country: 'Letônia', flag: '🇱🇻', iso2: 'LV' },
  { code: '+961', country: 'Líbano', flag: '🇱🇧', iso2: 'LB' },
  { code: '+231', country: 'Libéria', flag: '🇱🇷', iso2: 'LR' },
  { code: '+218', country: 'Líbia', flag: '🇱🇾', iso2: 'LY' },
  { code: '+423', country: 'Liechtenstein', flag: '🇱🇮', iso2: 'LI' },
  { code: '+370', country: 'Lituânia', flag: '🇱🇹', iso2: 'LT' },
  { code: '+352', country: 'Luxemburgo', flag: '🇱🇺', iso2: 'LU' },
  { code: '+853', country: 'Macau', flag: '🇲🇴', iso2: 'MO' },
  { code: '+389', country: 'Macedônia do Norte', flag: '🇲🇰', iso2: 'MK' },
  { code: '+261', country: 'Madagascar', flag: '🇲🇬', iso2: 'MG' },
  { code: '+60', country: 'Malásia', flag: '🇲🇾', iso2: 'MY' },
  { code: '+265', country: 'Malawi', flag: '🇲🇼', iso2: 'MW' },
  { code: '+960', country: 'Maldivas', flag: '🇲🇻', iso2: 'MV' },
  { code: '+223', country: 'Mali', flag: '🇲🇱', iso2: 'ML' },
  { code: '+356', country: 'Malta', flag: '🇲🇹', iso2: 'MT' },
  { code: '+212', country: 'Marrocos', flag: '🇲🇦', iso2: 'MA' },
  { code: '+596', country: 'Martinica', flag: '🇲🇶', iso2: 'MQ' },
  { code: '+230', country: 'Maurício', flag: '🇲🇺', iso2: 'MU' },
  { code: '+222', country: 'Mauritânia', flag: '🇲🇷', iso2: 'MR' },
  { code: '+52', country: 'México', flag: '🇲🇽', iso2: 'MX' },
  { code: '+95', country: 'Mianmar', flag: '🇲🇲', iso2: 'MM' },
  { code: '+691', country: 'Micronésia', flag: '🇫🇲', iso2: 'FM' },
  { code: '+258', country: 'Moçambique', flag: '🇲🇿', iso2: 'MZ' },
  { code: '+373', country: 'Moldávia', flag: '🇲🇩', iso2: 'MD' },
  { code: '+377', country: 'Mônaco', flag: '🇲🇨', iso2: 'MC' },
  { code: '+976', country: 'Mongólia', flag: '🇲🇳', iso2: 'MN' },
  { code: '+382', country: 'Montenegro', flag: '🇲🇪', iso2: 'ME' },
  { code: '+1664', country: 'Montserrat', flag: '🇲🇸', iso2: 'MS' },
  { code: '+264', country: 'Namíbia', flag: '🇳🇦', iso2: 'NA' },
  { code: '+674', country: 'Nauru', flag: '🇳🇷', iso2: 'NR' },
  { code: '+977', country: 'Nepal', flag: '🇳🇵', iso2: 'NP' },
  { code: '+505', country: 'Nicarágua', flag: '🇳🇮', iso2: 'NI' },
  { code: '+227', country: 'Níger', flag: '🇳🇪', iso2: 'NE' },
  { code: '+234', country: 'Nigéria', flag: '🇳🇬', iso2: 'NG' },
  { code: '+47', country: 'Noruega', flag: '🇳🇴', iso2: 'NO' },
  { code: '+687', country: 'Nova Caledônia', flag: '🇳🇨', iso2: 'NC' },
  { code: '+64', country: 'Nova Zelândia', flag: '🇳🇿', iso2: 'NZ' },
  { code: '+968', country: 'Omã', flag: '🇴🇲', iso2: 'OM' },
  { code: '+31', country: 'Países Baixos', flag: '🇳🇱', iso2: 'NL' },
  { code: '+680', country: 'Palau', flag: '🇵🇼', iso2: 'PW' },
  { code: '+970', country: 'Palestina', flag: '🇵🇸', iso2: 'PS' },
  { code: '+507', country: 'Panamá', flag: '🇵🇦', iso2: 'PA' },
  { code: '+675', country: 'Papua-Nova Guiné', flag: '🇵🇬', iso2: 'PG' },
  { code: '+92', country: 'Paquistão', flag: '🇵🇰', iso2: 'PK' },
  { code: '+595', country: 'Paraguai', flag: '🇵🇾', iso2: 'PY' },
  { code: '+51', country: 'Peru', flag: '🇵🇪', iso2: 'PE' },
  { code: '+689', country: 'Polinésia Francesa', flag: '🇵🇫', iso2: 'PF' },
  { code: '+48', country: 'Polônia', flag: '🇵🇱', iso2: 'PL' },
  { code: '+1787', country: 'Porto Rico', flag: '🇵🇷', iso2: 'PR' },
  { code: '+351', country: 'Portugal', flag: '🇵🇹', iso2: 'PT' },
  { code: '+254', country: 'Quênia', flag: '🇰🇪', iso2: 'KE' },
  { code: '+996', country: 'Quirguistão', flag: '🇰🇬', iso2: 'KG' },
  { code: '+44', country: 'Reino Unido', flag: '🇬🇧', iso2: 'GB' },
  { code: '+236', country: 'República Centro-Africana', flag: '🇨🇫', iso2: 'CF' },
  { code: '+1809', country: 'República Dominicana', flag: '🇩🇴', iso2: 'DO' },
  { code: '+420', country: 'República Tcheca', flag: '🇨🇿', iso2: 'CZ' },
  { code: '+262', country: 'Reunião', flag: '🇷🇪', iso2: 'RE' },
  { code: '+40', country: 'Romênia', flag: '🇷🇴', iso2: 'RO' },
  { code: '+250', country: 'Ruanda', flag: '🇷🇼', iso2: 'RW' },
  { code: '+7', country: 'Rússia', flag: '🇷🇺', iso2: 'RU' },
  { code: '+685', country: 'Samoa', flag: '🇼🇸', iso2: 'WS' },
  { code: '+1684', country: 'Samoa Americana', flag: '🇦🇸', iso2: 'AS' },
  { code: '+378', country: 'San Marino', flag: '🇸🇲', iso2: 'SM' },
  { code: '+290', country: 'Santa Helena', flag: '🇸🇭', iso2: 'SH' },
  { code: '+1758', country: 'Santa Lúcia', flag: '🇱🇨', iso2: 'LC' },
  { code: '+1869', country: 'São Cristóvão e Nevis', flag: '🇰🇳', iso2: 'KN' },
  { code: '+508', country: 'São Pedro e Miquelão', flag: '🇵🇲', iso2: 'PM' },
  { code: '+239', country: 'São Tomé e Príncipe', flag: '🇸🇹', iso2: 'ST' },
  { code: '+1784', country: 'São Vicente e Granadinas', flag: '🇻🇨', iso2: 'VC' },
  { code: '+221', country: 'Senegal', flag: '🇸🇳', iso2: 'SN' },
  { code: '+232', country: 'Serra Leoa', flag: '🇸🇱', iso2: 'SL' },
  { code: '+381', country: 'Sérvia', flag: '🇷🇸', iso2: 'RS' },
  { code: '+248', country: 'Seychelles', flag: '🇸🇨', iso2: 'SC' },
  { code: '+65', country: 'Singapura', flag: '🇸🇬', iso2: 'SG' },
  { code: '+963', country: 'Síria', flag: '🇸🇾', iso2: 'SY' },
  { code: '+252', country: 'Somália', flag: '🇸🇴', iso2: 'SO' },
  { code: '+94', country: 'Sri Lanka', flag: '🇱🇰', iso2: 'LK' },
  { code: '+268', country: 'Suazilândia', flag: '🇸🇿', iso2: 'SZ' },
  { code: '+249', country: 'Sudão', flag: '🇸🇩', iso2: 'SD' },
  { code: '+211', country: 'Sudão do Sul', flag: '🇸🇸', iso2: 'SS' },
  { code: '+46', country: 'Suécia', flag: '🇸🇪', iso2: 'SE' },
  { code: '+41', country: 'Suíça', flag: '🇨🇭', iso2: 'CH' },
  { code: '+597', country: 'Suriname', flag: '🇸🇷', iso2: 'SR' },
  { code: '+66', country: 'Tailândia', flag: '🇹🇭', iso2: 'TH' },
  { code: '+886', country: 'Taiwan', flag: '🇹🇼', iso2: 'TW' },
  { code: '+992', country: 'Tajiquistão', flag: '🇹🇯', iso2: 'TJ' },
  { code: '+255', country: 'Tanzânia', flag: '🇹🇿', iso2: 'TZ' },
  { code: '+670', country: 'Timor-Leste', flag: '🇹🇱', iso2: 'TL' },
  { code: '+228', country: 'Togo', flag: '🇹🇬', iso2: 'TG' },
  { code: '+676', country: 'Tonga', flag: '🇹🇴', iso2: 'TO' },
  { code: '+1868', country: 'Trinidad e Tobago', flag: '🇹🇹', iso2: 'TT' },
  { code: '+216', country: 'Tunísia', flag: '🇹🇳', iso2: 'TN' },
  { code: '+993', country: 'Turcomenistão', flag: '🇹🇲', iso2: 'TM' },
  { code: '+90', country: 'Turquia', flag: '🇹🇷', iso2: 'TR' },
  { code: '+688', country: 'Tuvalu', flag: '🇹🇻', iso2: 'TV' },
  { code: '+380', country: 'Ucrânia', flag: '🇺🇦', iso2: 'UA' },
  { code: '+256', country: 'Uganda', flag: '🇺🇬', iso2: 'UG' },
  { code: '+598', country: 'Uruguai', flag: '🇺🇾', iso2: 'UY' },
  { code: '+998', country: 'Uzbequistão', flag: '🇺🇿', iso2: 'UZ' },
  { code: '+678', country: 'Vanuatu', flag: '🇻🇺', iso2: 'VU' },
  { code: '+379', country: 'Vaticano', flag: '🇻🇦', iso2: 'VA' },
  { code: '+58', country: 'Venezuela', flag: '🇻🇪', iso2: 'VE' },
  { code: '+84', country: 'Vietnã', flag: '🇻🇳', iso2: 'VN' },
  { code: '+260', country: 'Zâmbia', flag: '🇿🇲', iso2: 'ZM' },
  { code: '+263', country: 'Zimbábue', flag: '🇿🇼', iso2: 'ZW' },
];


/**
 * Extrai o código de país de um número de telefone completo
 * Suporta números com ou sem o símbolo + (ex: +5562... ou 5562...)
 * Retorna o código encontrado ou '+55' (Brasil) como padrão
 */
export function extractCountryCode(phone: string | null | undefined): { countryCode: string; localNumber: string } {
  if (!phone) {
    return { countryCode: '+55', localNumber: '' };
  }

  // Remove caracteres não numéricos exceto + inicial
  const cleanPhone = phone.replace(/[^0-9+]/g, '');
  
  // Ordena por tamanho do código (maior primeiro) para evitar conflitos (+1 vs +11)
  const sortedCodes = [...countryCodes].sort((a, b) => b.code.length - a.code.length);
  
  for (const country of sortedCodes) {
    // Verifica se começa com o código completo (ex: +55)
    if (cleanPhone.startsWith(country.code)) {
      return {
        countryCode: country.code,
        localNumber: cleanPhone.slice(country.code.length),
      };
    }
    
    // Verifica se começa com os dígitos do código SEM o + (ex: 55)
    const digitsOnly = country.code.replace('+', '');
    if (cleanPhone.startsWith(digitsOnly) && !cleanPhone.startsWith('+')) {
      return {
        countryCode: country.code,
        localNumber: cleanPhone.slice(digitsOnly.length),
      };
    }
  }

  // Caso não encontre, assume Brasil e retorna o número limpo
  return { countryCode: '+55', localNumber: cleanPhone.replace(/^\+/, '') };
}
